module.exports = __webpack_public_path__ + "img/1.bd2f0c65.png";